import type { useGT } from 'gt-react';

export function bulkApplyToSelectedLinesLabel(
  gt: ReturnType<typeof useGT>,
  count: number,
): string {
  return gt('Apply to {n} selected lines', {
    context: 'bulk override apply to highlighted lines button',
    n: count,
  });
}
